import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import Title from '../../components/title/Title';
import { useForm } from 'react-hook-form';
import { decodeToken, getToken, login } from '../../services/auth';
import { ID_LAST_ROUTE } from '../../config/constants';
import { useDispatch} from 'react-redux';
import { actions as actionAuth} from './../../redux/actions/auth';
import './AreaRestrita.css';

const AreaRestrita = () => {

    const { register, handleSubmit } = useForm();
    //const tokenState = getToken();
    //const decoded = decodeToken(tokenState);
    const history = useHistory();
    const dispatch = useDispatch();

    const sendData = async data => {
        const logado = await login(data);
        if (logado) {
            dispatch(actionAuth.setToken(getToken()));
            const rotaPrivada = localStorage.getItem(ID_LAST_ROUTE);
            if (rotaPrivada) {
                localStorage.removeItem(ID_LAST_ROUTE);
                history.push(rotaPrivada);
            }
        }
    }

    const renderRestrictedArea = () => {
        return (
            <>
                <div className="text-restrita">
                    Para acessar essa área você precisa estar logado.
                </div>
                <div className="login-restrita">
                    <div className="title-restrita">
                        <span className="material-icons">face</span> &nbsp;Área da consultora
                    </div>
                    <div className="fields">
                        <form onSubmit={handleSubmit(sendData)}>
                            <input name="cpf" ref={register({ required: true })} placeholder="CPF" type="text" />
                            <input name="senha" ref={register({ required: true })} placeholder="Senha" type="password" />
                            <button type="submit">Entrar</button>
                        </form>
                    </div>
                    <div className="links">
                        <Link to="/esqueceu-senha">Esqueci minha senha</Link>
                        <Link to="/cadastro">Quero me cadastrar</Link>
                    </div>
                </div>
            </>
        )
    }

    return (
        <div className="background">
            <Title title="Login" />
            <div className="container">
                <div className="content">
                    {renderRestrictedArea()}
                </div>
            </div>
        </div>
    )
}

export default AreaRestrita